/** Links to records outside the portal. GoCardless has separate sandbox and live dashboards. */
const GC_DASHBOARD = import.meta.env.VITE_ENVIRONMENT === 'production' ? 'https://manage.gocardless.com' : 'https://manage-sandbox.gocardless.com';

export const gocardless = {
  payment: (id: string) => `${GC_DASHBOARD}/payments/${encodeURIComponent(id)}`,
  mandate: (id: string) => `${GC_DASHBOARD}/mandates/${encodeURIComponent(id)}`,
  customer: (id: string) => `${GC_DASHBOARD}/customers/${encodeURIComponent(id)}`,
  refund: (id: string) => `${GC_DASHBOARD}/refunds/${encodeURIComponent(id)}`,
};

const PP_SITE = import.meta.env.VITE_ENVIRONMENT === 'production' ? 'https://www.paypal.com' : 'https://www.sandbox.paypal.com';
export const paypal = {
  transaction: (id: string) => `${PP_SITE}/activity/payment/${encodeURIComponent(id)}`,
};

export const adminLinks = {
  person: (personId: string) => `/admin/people/${personId}`,
  household: (householdId: string, personId?: string) => `/admin/households/${householdId}${personId ? `#p-${personId}` : ''}`,
  dojo: (dojoId: string) => `/admin/dojos/${dojoId}`,
  instructorView: (dojoId: string) => `/dojo/${dojoId}`,
  event: (eventId: string) => `/admin/events/${eventId}`,
  emailBatch: (batchId: string) => `/admin/email/sent/${batchId}`,
  householdPayment: (householdId: string, paymentId: string) => `/admin/households/${householdId}#pay-${paymentId}`,
  /** Any line of the ledger: a payment, a refund or a chargeback. */
  payment: (id: string) => `/admin/payments/${id}`,
};

/** Pages a member sees: their household, a page per person in it, and the public dojo list. */
export const memberLinks = {
  person: (personId: string) => `/people/${personId}`,
  household: () => '/home',
  event: (slug: string) => `/events/${slug}`,
  dojo: (dojoId: string) => `/dojos#dojo-${dojoId}`,
};

/** Pages an instructor sees: My dojo, and a page per student. */
export const instructorLinks = {
  dojo: () => '/dojo',
  student: (personId: string) => `/people/${personId}`,
};
